<template>
  <FormContainer>
    <template #title>Tuteur au sein de l'établissement employeur</template>
    <template #content>
      <div class="form__bloc">
        <WrapperInput
          id="field_84"
          v-model="nomTuteurEtablissementModel"
          label="Nom"
          :required="meta.tutorat?.tuteurEntrepriseEmployeur?.nom?.$status === PropertyStatus.Required"
          :alertLabel="meta.tutorat?.tuteurEntrepriseEmployeur?.nom?.$messageErreurDirty!"
          hint="50 caractères maximum"
          class="col-9 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_NOM_NAIS"
          :maxlength="50"
          deletable
          :readonly
        />
        <WrapperInput
          id="field_85"
          v-model="prenomTuteurEtablissementModel"
          label="Prénom"
          :required="meta.tutorat?.tuteurEntrepriseEmployeur?.prenom?.$status === PropertyStatus.Required"
          :alertLabel="meta.tutorat?.tuteurEntrepriseEmployeur?.prenom?.$messageErreurDirty!"
          hint="50 caractères maximum"
          class="col-9 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_PRENOM"
          :maxlength="50"
          deletable
          :readonly
        />
        <WrapperInputDate
          id="field_86"
          v-model="dateNaissanceTuteurEtablissementModel"
          label="Date de naissance"
          :required="meta.tutorat?.tuteurEntrepriseEmployeur?.dateNaissance?.$status === PropertyStatus.Required"
          :alertLabel="meta.tutorat?.tuteurEntrepriseEmployeur?.dateNaissance?.$messageErreurDirty!"
          :hint="HINT_DATE"
          class="col-9 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_DATE_NAIS"
          deletable
          :readonly
        />
      </div>
      <div class="form__bloc">
        <WrapperToggleSwitch
          v-if="meta.tutorat?.tuteurEntrepriseEmployeur?.souhaiteAideFonctionTutorale?.$status !== PropertyStatus.NotPresent"
          id="field_206"
          v-model="souhaiteAideFonctionTutoraleModel"
          label="Souhaitez-vous bénéficier de l’Exercice de la fonction tutorale pour le Tuteur ETT ?"
          :required="
            meta.tutorat?.tuteurEntrepriseEmployeur?.souhaiteAideFonctionTutorale?.$status === PropertyStatus.Required
          "
          :alertLabel="meta.tutorat?.tuteurEntrepriseEmployeur?.souhaiteAideFonctionTutorale?.$messageErreurDirty!"
          :items="OuiOuNon"
          :readonly
          class="col-10 col-md-14 col-sm-36"
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
import {
  FormContainer,
  HINT_DATE,
  PLACEHOLDER_DATE_NAIS,
  PLACEHOLDER_NOM_NAIS,
  PLACEHOLDER_PRENOM,
} from '@/features/interface/demande/shared'
import { OuiOuNon } from '@/features/interface/shared/tools'
import { storeToRefs } from 'pinia'
import { useDemandePROAStore } from '../../../../useDemandePROAStore'

  const store = useDemandePROAStore()
  const { setupFieldWithKey } = store
  const { meta, readonly } = storeToRefs(store)

  const nomTuteurEtablissementModel = setupFieldWithKey<string>('tutorat.tuteurEntrepriseEmployeur.nom', true)
  const prenomTuteurEtablissementModel = setupFieldWithKey<string>('tutorat.tuteurEntrepriseEmployeur.prenom', true)
  const dateNaissanceTuteurEtablissementModel = setupFieldWithKey<string>(
    'tutorat.tuteurEntrepriseEmployeur.dateNaissance',
    true,
  )
  const souhaiteAideFonctionTutoraleModel = setupFieldWithKey<boolean>(
    'tutorat.tuteurEntrepriseEmployeur.souhaiteAideFonctionTutorale',
    true,
  )
</script>
